<template>
  <div class="dash-body">
    <div class="dash-header">
      <div class="dash-caption intro-pages-header" v-if="activeTab !== 'cm'">
        {{ $t('INTRO_MAIN_SOCIAL_MEDIA') }}
        <template v-if="(currentFilter !== groupByOwner || getAllowedAccesses.length <= 1) && getProfile.pageLimit">
          ({{ ownerAnalyzedCount  }}/{{ getProfile.pageLimit }})
        </template>
        <button class="add-plus" @click="INTRO_SET_ADD_PAGE_VISIBLE(true)">
          +
        </button>
        <div class="intro-page-search">
          <i
            :class="[searchInput ? 'bi bi-x-lg rd-btn' : 'bi bi-search']"
            @click="searchInput && (searchInput = '')"
          ></i>
          <input
            v-model="searchInput"
            type="text"
            :placeholder="$t('HEADER_SEARCH')"
          />
        </div>
        <button v-if="needRecollect" class="btn-st-tr reinit-btn" @click="recollectPages">{{ $t('INTRO_MAIN_REINIT') }}</button>
      </div>
      <div class="dash-options" :class="{ 'cm-options': activeTab === 'cm' }">
        <cm-filters v-if="activeTab === 'cm'" :show-scope-filters="true" />
        <span
          class="tags-sort"
          v-if="showTagsSort"
          :class="{ active: tagsSort }"
          :title="$t('INTRO_TAGS_SORT')"
          :aria-label="$t('INTRO_TAGS_SORT')"
          @click="cycleTagsSort"
        >
          <i :class="tagsSortIcon"></i>
        </span>
        <div
          class="drpdown displaying"
          v-click-outside="
            () => {
              isDisplayingBy = false;
            }
          "
          v-if="activeTab !== 'cm'"
        >
          <input type="checkbox" name id="z2" v-model="isDisplayingBy" />
          <label for="z2">
            <b>{{ $t('INTRO_MAIN_DISPLAYING_BY') }}</b>
            {{ $t(currentFilterKey) }}
          </label>
          <span class="expand"></span>
          <ul>
            <li
              v-if="currentFilter !== groupByName"
              @click.stop="setFilter(groupByName)"
            >
              {{ $t('INTRO_MAIN_BY_NAME') }}
            </li>
            <li
              v-if="currentFilter !== groupBySocial"
              @click.stop="setFilter(groupBySocial)"
            >
              {{ $t('INTRO_MAIN_BY_SOCIAL') }}
            </li>
            <li
              v-if="currentFilter !== groupByOwner && getAllowedAccesses.length > 1"
              @click.stop="setFilter(groupByOwner)"
            >
              {{ $t('INTRO_MAIN_BY_OWNER') }}
            </li>
            <li
              v-if="currentFilter !== groupByCategories && categoriesWithPages.length > 0"
              @click.stop="setFilter(groupByCategories)"
            >
              {{ $t('INTRO_MAIN_BY_GROUPS') }}
            </li>
          </ul>
        </div>
        <div class="options-side">
          <calendar
            :callback="INTRO_SET_PAGES"
            :disabledDates="getDisabledDates"
          />
          <cm-report-button v-if="activeTab === 'cm'" :pages="getPages" />
          <report-button v-else />
        </div>
        
      </div>
    </div>
    <!-- <div>
      <p>{{ $t('INTRO_START_CURRENLY_PLAN') }}</p>
    </div> -->

    <p v-if="activeTab === 'cm' && !cmMounted" class="cm-state">{{ $t('CM_LOADING') }}</p>
    <keep-alive>
      <Dash-content-monitoring
        v-if="cmMounted && activeTab === 'cm'"
        key="cm"
        :pages="getPages"
      />
    </keep-alive>

    <div v-if="pagesMounted" v-show="activeTab === 'pages'">
    <div v-if="currentFilter === groupBySocial">
      <intro-list
        v-if="getPagesBySocial['FB'].length"
        :pages="getPagesBySocial['FB']"
        social="fb"
        socialName="Facebook"
      ></intro-list>
      <intro-list
        v-if="getPagesBySocial['IG'].length"
        :pages="getPagesBySocial['IG']"
        social="ig"
        socialName="Instagram"
      ></intro-list>
      <intro-list
        v-if="getPagesBySocial['VK'].length"
        :pages="getPagesBySocial['VK']"
        social="vk"
        socialName="VK"
      ></intro-list>
      <intro-list
        v-if="getPagesBySocial['TG'].length"
        :pages="getPagesBySocial['TG']"
        social="tg"
        socialName="Telegram"
      ></intro-list>
    </div>
    <div v-if="currentFilter === groupByName">
      <intro-list :pages="getPagesByName"></intro-list>
    </div>
    <div v-if="currentFilter === groupByOwner">
      <intro-list
        :key="owner.email"
        :email="owner.email"
        :pages="owner.pages"
        v-for="owner in sortedTables(getPagesByOwners, 'email')"
      ></intro-list>
    </div>
    <div v-if="currentFilter === groupByCategories">
      <intro-list
        :key="category.id"
        :categoryName="category.name"
        :categoryId="category.id"
        :pages="category.pages"
        v-for="category in sortedTables(categoriesWithPages, 'name')"
      ></intro-list>
    </div>
    <div v-if="getDeletedPages.length">
      <span class="deleted-list">
        {{ $t('DASHBOARD_DELETED') }}:
        <span class="deleted-disclaimer">
          {{ $t('DASHBOARD_DELETED_DISCLAIMER') }}
        </span>
      </span>
      
      <intro-list
        :key="index"
        :email="owner.email"
        :pages="owner.pages"
        v-for="(owner, index) in getDeletedPagesByOwners"
      ></intro-list>
    </div>
    <div class="intro-helper">
      <p>
        {{  $t('INTRO_HELPER_TEXT') }}
      </p>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  INTRO_SET_ADD_PAGE_VISIBLE,
  INTRO_SET_FILTER,
  INTRO_SET_SELECTED,
  INTRO_SET_PAGES,
  INTRO_UPDATE_STATUS_PAGES,
  INTRO_SET_ALERT,
  INTRO_SET_ACTIVE_TAB,
  INTRO_SET_SEARCH_INPUT,
} from "../../../store/actions/intro";
import IntroList from "./Intro-list";
import Calendar from "../../../components/Calendar";
import ReportButton from "../../../components/ReportButton";
import CmReportButton from "../../Dashboard/ContentMonitoring/Cm-report-button";
import ClickOutside from "vue-click-outside";
import AxiosModule from "@/models/AxiosModule";
import DashContentMonitoring from "../../Dashboard/ContentMonitoring/Dash-content-monitoring";
import CmFilters from "../../Dashboard/ContentMonitoring/Cm-filters";

export default {
  name: "Intro-main",
  components: {
    IntroList,
    ReportButton,
    CmReportButton,
    Calendar,
    DashContentMonitoring,
    CmFilters,
  },
  computed: {
    ...mapGetters([
      "getIntroFilterType",
      "getPeriod",
      "getAddedHashes",
      "getAddedHashesWithTimestamps",
      "getSelectedPages",
      "getProfile",
      "getPagesByName",
      "getPagesBySocial",
      "getAlertStatus",
      "getAlertText",
      "getPagesByOwners",
      "getAllowedAccesses",
      "getDisabledDates",
      "getDeletedPages",
      "getDeletedPagesByOwners",
      "getPages",
      "getPagesBySearchWord",
      "getCategoriesByPages",
      "getCategories",
      "getIntroActiveTab",
      "getSearchInputText",
    ]),
    activeTab: {
      get() {
        return this.getIntroActiveTab;
      },
      set(tab) {
        this.INTRO_SET_ACTIVE_TAB(tab);
      },
    },
    searchInput: {
      get() {
        return this.getSearchInputText;
      },
      set(value) {
        this.INTRO_SET_SEARCH_INPUT(value);
      },
    },
    currentFilterKey() {
      if (this.currentFilter === "By Name") {
        return 'INTRO_MAIN_BY_NAME';
      } else if (this.currentFilter === "By Social") {
        return 'INTRO_MAIN_BY_SOCIAL';
      } else if (this.currentFilter === "By Owner") {
        return 'INTRO_MAIN_BY_OWNER';
      } else if (this.currentFilter === "By Groups") {
        return 'INTRO_MAIN_BY_GROUPS';
      }
    },
    ownerAnalyzedCount() {
      // Determine the owner's email we should count for:
      // If grouping by owner and multiple accesses, the counts are shown in each Intro-list already.
      // If not grouping by owner or only one access, use the current profile's email (as there's only one owner).
      if (this.currentFilter !== this.groupByOwner || this.getAllowedAccesses.length <= 1) {
        const ownerEmail = this.getProfile.email;
        // Count how many pages belong to this owner and are currently analyzed (use search-filtered pages)
        return this.getPagesBySearchWord.filter(p => p.email === ownerEmail && p.status !== 'deleted').length;
      }
      return 0;
    },
    needRecollect() {
      return this.getProfile.recollect === 1;
    },
    categoriesWithPages() {
      const result = [];
      const usedPageIds = new Set();
      
      // Use search-filtered pages for category display
      const filteredPages = this.getPagesBySearchWord.filter(page => page.status !== 'deleted');
      
      // Add categorized pages
      this.getCategories.forEach(category => {
        if (category.pages && category.pages.length > 0) {
          // Extract page_ids from the category
          const categoryPageIds = category.pages.map(p => p.page_id);
          
          // Find matching pages from the search-filtered pages list
          const categoryPages = filteredPages.filter(page => 
            categoryPageIds.includes(page.page_id)
          );
          
          if (categoryPages.length > 0) {
            result.push({
              id: category.id,
              name: category.name,
              pages: categoryPages
            });
            
            // Track which pages we've used
            categoryPages.forEach(page => usedPageIds.add(page.page_id));
          }
        }
      });
      
      // Add uncategorized pages from search-filtered results
      const uncategorizedPages = filteredPages.filter(page => 
        !usedPageIds.has(page.page_id)
      );
      
      if (uncategorizedPages.length > 0) {
        result.push({
          id: 'uncategorized',
          name: this.$t('INTRO_MAIN_UNCATEGORIZED'),
          pages: uncategorizedPages
        });
      }
      
      return result;
    },
    showTagsSort() {
      if (this.activeTab !== "pages") return false;
      if (this.currentFilter === this.groupByOwner) {
        return this.getPagesByOwners.length > 1;
      }
      if (this.currentFilter === this.groupByCategories) {
        return this.categoriesWithPages.length > 1;
      }
      return false;
    },
    tagsSortIcon() {
      return this.tagsSort === "za"
        ? "bi bi-sort-alpha-up"
        : "bi bi-sort-alpha-down";
    },
  },
  methods: {
    ...mapActions([INTRO_SET_PAGES, INTRO_UPDATE_STATUS_PAGES, "CATEGORIES_SET_LIST"]),
    ...mapMutations([
      INTRO_SET_ADD_PAGE_VISIBLE,
      INTRO_SET_FILTER,
      INTRO_SET_SELECTED,
      INTRO_SET_ALERT,
      INTRO_SET_ACTIVE_TAB,
      INTRO_SET_SEARCH_INPUT,
    ]),
    updatePages() {
      this.startPolling();
    },
    
    startPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
      
      const timeout = this.calculatePollingTimeout();
      this.currentTimeout = timeout;
      
      this.pollingInterval = setInterval(() => {
        if (!this.getAddedHashes.length) {
          this.stopPolling();
          return;
        }
        
        // Check if we need to adjust the timeout
        const newTimeout = this.calculatePollingTimeout();
        if (newTimeout !== this.currentTimeout) {
          this.startPolling(); // Restart with new timeout
          return;
        }
        
        this.INTRO_UPDATE_STATUS_PAGES();
      }, timeout);
    },
    
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    
    calculatePollingTimeout() {
      if (!this.getAddedHashesWithTimestamps.length) {
        return 5000; // Default 5 seconds
      }
      
      const now = Date.now();
      const oldestTimestamp = Math.min(...this.getAddedHashesWithTimestamps.map(item => item.timestamp));
      const elapsedMinutes = (now - oldestTimestamp) / (1000 * 60);
      
      // Progressive timeouts based on elapsed time:
      // 0-15 minutes: 5 seconds
      // 15 minutes-1 hour: 15 seconds  
      // 1 hour-1 day: 1 minute
      // After 1 day: 10 minutes
      
      if (elapsedMinutes < 15) {
        return 5000; // 5 seconds
      } else if (elapsedMinutes < 60) {
        return 15000; // 15 seconds
      } else if (elapsedMinutes < 1440) { // 24 hours = 1440 minutes
        return 60000; // 1 minute
      } else {
        return 600000; // 10 minutes
      }
    },
    setFilter(filter) {
      this.currentFilter = filter;
      this.isDisplayingBy = false;
      localStorage.setItem('introCurrentFilter', filter);
    },
    cycleTagsSort() {
      this.tagsSort = this.tagsSort === "" ? "az" : this.tagsSort === "az" ? "za" : "";
    },
    sortedTables(list, key) {
      if (!this.tagsSort) return list;
      const sorted = list.slice().sort((a, b) =>
        String(a[key] || "").localeCompare(String(b[key] || ""), undefined, {
          sensitivity: "base",
        })
      );
      return this.tagsSort === "za" ? sorted.reverse() : sorted;
    },
    /**
     * Монтируем CM после кадра отрисовки кнопки/таба — иначе синхронный
     * resolve+5 секций+echarts на том же тике «замораживает» DOM.
     * keep-alive потом держит инстанс между переключениями.
     */
    scheduleCmMount() {
      if (this.cmMounted || this._cmMountScheduled) return;
      this._cmMountScheduled = true;
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.cmMounted = true;
          this._cmMountScheduled = false;
        });
      });
    },
    recollectPages() {
      AxiosModule.Axios.post('recollect-user-pages', { email: this.getProfile.email })
        .then(response => {
          if (response.data && response.data.success) {
            this.$store.dispatch('alerts/addAlert', {
              message: 'Пересборка страниц запущена',
              color: 'success',
              duration: 5000
            });
          }
        })
        .catch(error => {
          this.$store.dispatch('alerts/addAlert', {
            message: 'Ошибка при запуске пересборки страниц',
            color: 'error',
            duration: 5000
          });
        });
    },
  },
  mounted() {
    this.popupItem = document.getElementsByClassName("displaying")[0];
    this.updatePages();
    this.$store.dispatch("CATEGORIES_SET_LIST");
    if (this.activeTab === "cm") this.scheduleCmMount();
  },
  
  beforeDestroy() {
    this.stopPolling();
  },
  
  watch: {
    activeTab(tab) {
      if (tab === "cm") this.scheduleCmMount();
      if (tab === "pages") this.pagesMounted = true;
    },
    getAddedHashes: {
      handler(newHashes, oldHashes) {
        // Start polling when pages are added, stop when all are done
        if (newHashes.length > 0 && !this.pollingInterval) {
          this.startPolling();
        } else if (newHashes.length === 0 && this.pollingInterval) {
          this.stopPolling();
        }
      },
      immediate: false
    }
  },
  data() {
    const savedTab = sessionStorage.getItem("introActiveTab") === "cm" ? "cm" : "pages";
    return {
      isDisplayingBy: false,
      groupByName: "By Name",
      groupBySocial: "By Social",
      groupByOwner: "By Owner",
      groupByCategories: "By Groups",
      currentFilter: localStorage.getItem('introCurrentFilter') || "By Name",
      tagsSort: "",
      pollingInterval: null,
      currentTimeout: 5000, // Current polling timeout in milliseconds
      cmMounted: false,
      // pages-список не монтируем сразу, если старт с CM — иначе двойная нагрузка
      pagesMounted: savedTab === "pages",
    };
  },
  directives: {
    ClickOutside,
  },
};
</script>


<style></style>
